import PrintLayout from './printLayout'
import queuePrint from '@/plugins/printQueue'
import StoreAPI from '@/api/store'
import Utils from '@/utils'
import Storage2 from '@/plugins/storage2'

export async function Print (data, type = 'pedidos', trigger = 'reprintTicket', printer = '', format = 56, bluetooth = false) {
  if (data == 'test') {
    data = dataTest();
	  let printLayout = new PrintLayout(data, format);
	
    let layoutData = (type == 'try') ? await printLayout.generateFixedLayout() : await printLayout.generateTestLayout();
    // let layoutData = (type == 'try') ? await printLayout.generatePrintLayout() : await printLayout.generateTestLayout();
    // let layoutData = await printLayout.generateTestLayout();
	  // let layoutData = await printLayout.generatePrintLayout(false, true);

    let dataPrint = {
      printer: printer.name,
      info: layoutData,
      brand: (printer.brand) ? printer.brand : 'escpos'
    }

    if (bluetooth) {
      return dataPrint
    }

    queuePrint.print(dataPrint)
  } else {
    let printers = []

    if (data.bluetooth) {
      let bluetoothConfig = Storage2.get('local', 'bluetoothConfigurations');
      printers = bluetoothConfig && bluetoothConfig.printers ? bluetoothConfig.printers : []; 
    } else {
      printers = await getPrinters();
    }
    
    const avaliableLayouts = getAvaliableLayouts(printers, type, trigger);	

    for (let avaliablelayout of avaliableLayouts) {   
      const printLayout = new PrintLayout(JSON.parse(JSON.stringify(data)), avaliablelayout.width, avaliablelayout, trigger);
      const reprint = trigger == 'reprintTicket' ? true : false;
      const layoutData = await printLayout.generateLayout(false, reprint, avaliablelayout);
      
      const dataPrint = {
        printer: avaliablelayout.name,
        mac: avaliablelayout.mac,
        info: layoutData,
        brand: avaliablelayout.brand
      };
      
      await queuePrint.print(dataPrint);
    }
  }        
}

function getAvaliableLayouts (printers, type, trigger) {
  let layouts = []
  
  for (let printer of printers) {
    if (printer.type[type]) {
      for (let y in printer.layouts) {
        if (printer.layouts[y][trigger]) {
          printer.layouts[y].name = printer.name
          printer.layouts[y].mac = printer.mac ? printer.mac : null
          printer.layouts[y].width = printer.width
		  printer.layouts[y].brand = printer.brand ? printer.brand : 'escpos';
          layouts.push(printer.layouts[y])
        }
      }
    }
  }
  return layouts
}

function getPrinters () {
  return new Promise((resolve) => {
    StoreAPI.storeGetConfiguration('printers').then((response) => {
      resolve(response._data.printers)
    }).catch(error => {
      resolve([])
    })
  })
}

function dataTest () {
    return {
        "payment":{  
            "payers":[  
              {  
                  "user":{  
                    "email":"cliente@veasy.com.br",
                    "name":"Nome do Cliente",
                    "phone":"41991234567"
                  },
                  "method":"MASTERCARD",
                  "amount":11,
                  "changeFor":null,
                  "status":2,
                  "aproove":1
              }
            ],
            "total":11,
            "status":1
        },
        "cart":{  
            "catalog":{  
              "type":"catalog",
              "items":[  
                  {  
                    "_id":"5d3f424362b2b07b8a71fb85",
                    "ref_id":"5d3f424362b2b07b8a71fb84",
                    "type":"simple",
                    "parent":"5d3f3d2462b2b00b50479753",
                    "position":0,
                    "name":"Refrigerante",
                    "price":10,
                    "image":null,
                    "description":null,
                    "new":false,
                    "delete":false,
                    "show":true
                  }
              ]
            },
            "total":10
        },
        "delivery":{  
            "address":{  
              "address":'Avenida de teste, 123',
              "city": 'Curitiba',
              "region": 'Centro',
              "state": 'PR'
            },
            "type":2,
            "price":5, // Ignorar
            "total":5
        },
        "gift":{  
            "code": 'SEXTA10',
            "value": 4
        },
        "total":11,
        "subtotal":null,
        "order_id":1234,
        "updated_by":834,
        "created_by":834,
        "created_at": Utils.dateParse(new Date())
    }
}